import React from 'react';
import { ClinicInfoPanel } from '../info/clinicInfoParts';

function RecallHoursText({ clinicHours }) {
    if (!clinicHours?.length) {
        return null;
    }

    return (
        <ClinicInfoPanel title="Recall Hours" icon="bi-clock-history">
            <div className="clinic-settings-hours-list">
                {clinicHours.map((item, index) => (
                    <div key={index} className="clinic-settings-hours-item">
                        <div className="clinic-settings-hours-item__day">{item.day}</div>
                        <div className="clinic-settings-hours-item__time">
                            {item.start} – {item.end}
                        </div>
                        <span className="clinic-settings-status-pill is-open">
                            <i className="bi bi-clock"></i>
                            Active
                        </span>
                        {item.note && (
                            <div className="clinic-settings-hours-item__note">
                                <i className="bi bi-chat-left-text me-1"></i>
                                {item.note}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </ClinicInfoPanel>
    );
}

export default RecallHoursText;
